module.exports = __webpack_public_path__ + "img/Puente_Istobal_MWASH4_Alto_Blanco-default-front.eb4384f8.jpg";